<template>
  <transition name="fade">
    <div class="modal">
      <div class="modal__dialog">
        <div class="modal__body">
          <div class="d-flex flex-column">
            <img
              src="../assets/app-icon.png"
              alt="Gucci App icon"
              class="app-icon"
            />
            <p class="">{{ t("modal_message") }}</p>
            <div class="buttons-group">
              <button @click="openApp()">{{ t("modal_yes") }}</button>
              <button @click="openStore()">{{ t("modal_no") }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>

  <div id="homepage"></div>
</template>

<i18n>
{
  "de": {
    "modal_message": "Haben Sie schon die Gucci App?",
    "modal_yes": "JAWOHL",
    "modal_no": "NEIN"
  },
  "en": {
    "modal_message": "Do you have the Gucci App?",
    "modal_yes": "YES",
    "modal_no": "NO"
  },
  "es": {
    "modal_message": "¿Ya tiene la aplicación de Gucci?",
    "modal_yes": "SÍ",
    "modal_no": "NO"
  },
  "fr": {
    "modal_message": "Avez-vous l’application Gucci?",
    "modal_yes": "OUI",
    "modal_no": "NON"
  },
  "it": {
    "modal_message": "Hai già la Gucci App?",
    "modal_yes": "SÌ",
    "modal_no": "NO"
  },
  "ja": {
    "modal_message": "グッチのアプリをお持ちですか？",
    "modal_yes": "はい",
    "modal_no": "いいえ"
  },
  "ko": {
    "modal_message": "구찌 앱을 사용하고 계신가요?",
    "modal_yes": "예",
    "modal_no": "아니요"
  },
  "zh": {
    "modal_message": "您是否下载了Gucci App？",
    "modal_yes": "是的",
    "modal_no": "不"
  }
}
</i18n>

<script>
import { useI18n } from "vue-i18n";
export default {
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local"
    });
    return { t };
  },

  methods: {
    openApp() {
      const queryString = window.location.search;
      const params = new URLSearchParams(queryString);
      const stage = params.get("stage");

      let scheme = "gucciapp";
      if (stage) scheme += `-${stage}`;
      const url = new URL(`${scheme}://open`);
      for (const [key, value] of params) {
        url.searchParams.append(key, value);
      }

      window.open(url.toString());
    },

    openStore() {
      let url;
      const userAgent = navigator.userAgent;
      if (/android/i.test(userAgent)) {
        url = new URL(
          "https://play.google.com/store/apps/details?id=com.gucci.gucciapp"
        );
      } else if (/iPad|iPhone|iPod|Macintosh/i.test(userAgent)) {
        url = new URL("https://apps.apple.com/it/app/gucci/id334876990");
      }
      if (url) {
        window.open(url.toString());
      }
    }
  }
};
</script>

<style scoped>
#homepage {
  flex: 1;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-image: url("../assets/background.jpg");
  background-size: cover;
  background-position: center;
}

.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
.modal__dialog {
  position: relative;
  width: 90%;
  max-width: 291px;
  background-color: #ffffff4d;
  border-radius: 1rem;
  margin: auto;
  display: flex;
  flex-direction: column;
  z-index: 2;
}
.modal__body {
  padding: 1.5rem 2.5rem 2.5rem;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.app-icon {
  height: 3.325rem;
  width: 3.325rem;
  margin: auto;
}

.modal__dialog p {
  font-size: 1.1875rem;
  font-family: "GucciSansPro";
  font-weight: 700;
  text-align: center;
}
.modal__dialog .buttons-group {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  column-gap: 1rem;
  row-gap: 1rem;
  margin: 0 0.5rem;
}
.modal__dialog button {
  font-size: 1.0625rem;
  font-family: "GucciSansPro";
  font-weight: 700;
  padding: 0.5rem 1rem;
  background: black;
  color: white;
  border: none;
  border-radius: 1rem;
  cursor: pointer;
  flex: 1;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.d-flex {
  display: flex;
  flex-direction: row;
}
.flex-column {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
</style>
